'use client';

import dynamic from 'next/dynamic';

import {
  Header,
  HeroSection,
  IntelligentForce,
  PartnerCategories,
  PathToGrowth,
  TrustedPartners,
  WhyPartnerWithHafla
} from 'components/atomic/atoms';
import { LandingPageFooter } from 'components/atomic/molecules';

const AnimatedBubbleBackground = dynamic(
  () =>
    import('components/atomic/atoms').then(
      (mod) => mod.AnimatedBubbleBackground
    ),
  { ssr: false }
);

const HeroMobileShowcase = dynamic(() =>
  import('components/atomic/atoms').then((mod) => mod.HeroMobileShowcase)
);

const PartnerSuccessStories = dynamic(() =>
  import('components/atomic/atoms').then((mod) => mod.PartnerSuccessStories)
);

const FrequentlyAskedQuestions = dynamic(() =>
  import('components/atomic/atoms').then((mod) => mod.FrequentlyAskedQuestions)
);

const LandingPage = () => (
  <main className='relative w-full flex flex-col items-center justify-center pt-6 sm:pt-5'>
    <AnimatedBubbleBackground />
    <Header />
    <HeroSection />
    <TrustedPartners />
    <PartnerCategories />
    <WhyPartnerWithHafla />
    <PathToGrowth />
    <IntelligentForce />
    <PartnerSuccessStories />
    <HeroMobileShowcase />
    <FrequentlyAskedQuestions />
    <LandingPageFooter />
  </main>
);

export default LandingPage;
